import { render, staticRenderFns } from "./BaseListGroup.vue?vue&type=template&id=8602db0a"
import script from "./BaseListGroup.vue?vue&type=script&lang=js"
export * from "./BaseListGroup.vue?vue&type=script&lang=js"
import style0 from "./BaseListGroup.vue?vue&type=style&index=0&id=8602db0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VListGroup})
